module.exports = __webpack_public_path__ + "static/media/mercedes_06.3f2e9dc9.png";